import { ChangeDetectionStrategy, Component, ElementRef, input, output, ViewChild } from '@angular/core';
import { CdkDragDrop, DragDropModule, moveItemInArray } from '@angular/cdk/drag-drop';
import { IconComponent } from '@outlaw/icons';
import { Image } from '../../../interfaces/community-item';

@Component({
  selector: 'outlaw-image-grid',
  templateUrl: './image-grid.component.html',
  styleUrls: ['./image-grid.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DragDropModule, IconComponent],
})
export class ImageGridComponent {
  @ViewChild('gridContainer') gridContainer!: ElementRef<HTMLDivElement>;

  images = input.required<Image[]>();
  uploadingCount = input(0);
  imageRemoved = output<number>();
  imagesReordered = output<Image[]>();

  #isDragging = false;
  #startX = 0;
  #scrollLeft = 0;

  onDrop(event: CdkDragDrop<Image[]>): void {
    const updated = [...this.images()];
    moveItemInArray(updated, event.previousIndex, event.currentIndex);
    this.imagesReordered.emit(updated);
  }

  onMouseDown(event: MouseEvent): void {
    const el = this.gridContainer?.nativeElement;
    if (!el) return;
    this.#isDragging = true;
    this.#startX = event.pageX - el.offsetLeft;
    this.#scrollLeft = el.scrollLeft;
    el.style.cursor = 'grabbing';
  }

  onMouseMove(event: MouseEvent): void {
    if (!this.#isDragging) return;
    event.preventDefault();
    const el = this.gridContainer.nativeElement;
    const x = event.pageX - el.offsetLeft;
    el.scrollLeft = this.#scrollLeft - (x - this.#startX);
  }

  onMouseUp(): void {
    this.#isDragging = false;
    const el = this.gridContainer?.nativeElement;
    if (el) el.style.cursor = 'grab';
  }
}
